export const noPreviewImage ="/assets/images/NoPreview.jpg"
export const badgesImage ="/assets/images/badges.png"
export const accountingImage ="/assets/images/accounting2.png"
export const engineerImage ="/assets/images/image1.png"
export const teacherImage ="/assets/images/image2.png"
export const iconClick = "/assets/images/clickeach.svg"
